import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const CheckoutAlert = ({ isOpen, onClose, packageId }) => {
  const navigate = useNavigate();

  const handleNavigateToCheckout = () => {
    navigate('/check-out', {
      state: { FromCheckoutAlert: 'FromCheckoutAlert', packageId: packageId },
    });
    window.scrollTo(0, 0);
  };

  const handleNavigateToLogin = () => {
    navigate('/login', { state: { FromCheckoutAlert: 'FromCheckoutAlert' } });
    window.scrollTo(0, 0);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-15 z-50 text-xs md:text-sm">
      <div className="bg-white rounded-lg md:px-10 px-6 py-4 shadow-lg text-center max-w-lg md:w-auto w-80 relative">
        <button
          onClick={onClose}
          className="absolute text-sm md:text-lg top-2 right-2 text-gray-500 hover:text-gray-700"
        >
          &times;
        </button>
        <h2 className="md:text-xl text-sm font-bold text-gray-800 mb-4">
          Choose an option
        </h2>
        <p className="text-gray-600 md:mb-6 mb-4 text-justify text-xs">
          <span className="font-bold">1.</span> By selecting 'Pay Now' option to
          become a premium member, you'll receive your user credentials via SMS
          after successful payment. Use the temporary password to log in and
          then change it to one of your choice.
        </p>
        <p className="text-gray-600 md:mb-6 mb-4 text-justify text-xs">
          <span className="font-bold">2.</span> If you choose the 'Pay After
          Login' option and haven't registered yet, please register, log in, and
          then select your preferred package.
        </p>
        <div className="flex justify-center items-center gap-4 w-full text-xs">
          <button
            onClick={handleNavigateToLogin}
            className="md:w-1/3 w-1/2 border-2 border-orange-500 text-orange-500 hover:bg-orange-100 py-1.5 px-4 rounded-md font-medium "
          >
            Pay After Login
          </button>
          <button
            onClick={handleNavigateToCheckout}
            className="bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md font-medium md:w-1/3 w-1/2"
          >
            Pay Now
          </button>
        </div>
      </div>
    </div>
  );
};
